import { useEffect, useState } from 'react'
import { useSWRConfig }        from 'swr'
import { useFetch }            from 'hooks/fetch/useFetch'
import { usePrevious }         from 'hooks/usePrevious'
import { _project }            from 'state/store.projects'
import { setFocus, getFocus }  from 'state/jotai'
import { fn3 }                 from 'utilities/utility.misc'
import { applyfilters }        from 'utilities/utility.filter'
import { applysorting }        from 'utilities/utility.sort'
import { useTranslation }      from 'react-i18next'
import { UNITS, VERSION }      from 'api/api'

export const useFetch_Units = ({ pid=null, pin=null } = {}) => {

  const { i18n:{language} } = useTranslation()

  const [ version, setVersion ] = useState(0)
  const [ init, setInit ]       = useState(false)

  const filters            = getFocus(_project, 'activefilters')?.[pin]?.[pid]
  const sorting            = getFocus(_project, 'activesorting')?.[pin]?.[pid]
  const setUnits           = setFocus(_project, 'units')
  const setRaw             = setFocus(_project, 'unitsraw')
  const setCategories      = setFocus(_project, 'unitcategories')
  const setHouseCategories = setFocus(_project, 'housecategories')
  const setFilterTypes     = setFocus(_project, 'filtertypes')

  const done        = d => setVersion(d.Dataversion)
  const update      = useSWRConfig().mutate
  const prevVersion = usePrevious(version)

  const file = 'useFetch_Units.jsx'
  const sec  = 10

  const url1 = pid ? VERSION(pid) : null
  const url2 = pid ? UNITS(pid,language) : null

  const {     } = useFetch({ url:url1, file, sec, done })
  const {D,L,E} = useFetch({ url:url2, file })

  useEffect(()=>{

    if ( prevVersion !== version && init !== false ) update( url2 )
    if ( D && pin >= 0 ) {
      setInit(true)
      
      const { Units, ...rest } = D
      const units_f            = applyfilters( Units, filters )
      const units_s            = applysorting( units_f, sorting )
      const units              = { ...rest, Units:units_s }

      const raws_s = applysorting( Units, sorting )
      const raws   = { ...rest, Units:raws_s }

      const cats  = Units.map(i=>i?.Data?.Boligtype?.Value)
      const cats1 = Units.map(i=>i?.Data?.Husnrfilter?.Value)

      const propertyFilterTypes = [
        {
          atomKey     : "unitcategories",
          propertyKey : "Boligtype",
          label       : "Boligtype",
          labelProperty: "AlleBoligtyper"
        }, 
        {
          atomKey     : "housecategories",
          propertyKey : "Husnrfilter",
          label       : "Hus",
          labelProperty: "Allehuse"
        }
      ]
        
      const cats_  = ['Alle boligtyper',...cats]
      const cats1_ = ['Alle huse',...cats1]

      const unitcategories = [...new Set(cats_)]
      const huscategories  = [...new Set(cats1_)]

          // clog( 'unitcategories', huscategories )

      setFilterTypes (a => fn3(a,pin,pid,propertyFilterTypes) )
      setCategories  (a => fn3(a,pin,pid,unitcategories) )
      setHouseCategories(a => fn3(a,pin,pid,huscategories))
      setUnits       (a => fn3(a,pin,pid,units) )
      setRaw         (a => fn3(a,pin,pid,raws) )
      
    } 

  },[version,D])

  return {D,L,E}

}